// Import Firebase SDK functions
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration (DEFINE FIRST)
const firebaseConfig = {
  apiKey: "AIzaSyDq_KtMeaNHharbScyDhaUBL0bmvwDW778",
  authDomain: "xluxe-bfd80.firebaseapp.com",
  projectId: "xluxe-bfd80",
  storageBucket: "xluxe-bfd80.firebasestorage.app",
  messagingSenderId: "1017132104894",
  appId: "1:1017132104894:web:6f32bb70a5f0f73a95b2ef",
  measurementId: "G-865XNXK7T5"
};

// Debug check (optional – remove later)
console.log("ENV CHECK:", process.env.REACT_APP_FIREBASE_API_KEY);

// Initialize Firebase app (AFTER config)
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
